const openingScheduleReducer = (state = { list : [], selected: null }, action) => {
  switch (action.type) {
    case "GET_OPENING_SCHEDULES_LIST_SUCCESS":
      return { ...state, list: action.payload }
    case "GET_OPENING_SCHEDULE_DETAILS_SUCCESS":
      return { ...state, selected: action.payload }
    default:
      return state
  }
}

export default openingScheduleReducer